





































































































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    matchedIndexIdInArray
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    Input,
    CloseConfirmationModal
} from '../../core/components';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { emailValidator } from '../../core/utils/validations';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        DatePickerSingle,
        Input
    }
})
export default class ModalVehicleHomologation extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() patchData: object | null;
    @Prop() visible: boolean;
    @Prop() vehicleVin: number;
    @Prop() vehicleID: number;
    @Prop() isSowing: boolean;
    @Prop() cropTypes: Array<object>;
    sensorStateOptions: Array<object> = [];
    cropTypeSelected: any = null;
    cropTypeRV: boolean = false;
    flowStateSelected: any = null;
    flowStateRV: boolean = false;
    humiditySelected: any = null;
    humidityRV: boolean = false;
    location: string = '';
    monitorType: string = '';
    modalTitle: string = '';
    dateSelected: any = null;
    errorMsg: string = '';
    workWidthValue: any = null;
    flowSensorState: any = null;
    vinValue: any = null;
    emailValue: string = '';
    independentSections: string = '';
    noteDescription: string = '';
    locationSelected: google.maps.LatLng | null = null;
    dateAcknowledge: any = null;
    firstTab: string = 'select_info';
    secondTab: string = 'view_map';

    get mapHomologation(): HTMLFormElement {
        return this.$refs.mapHomologation as HTMLFormElement;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    saveHomologation() {
        let data = this.getData;
        if (!this.isPatch) {
            this.postHomologation(data);
        } else {
            this.patchHomologation(data);
        }
    }

    postSowingHomologation(data) {
        InsuranceServices.postSowingHomologation(data)
            .then(res => {
                this.showSuccessLoadingDialog(res, 'Homologación creada con éxito');
                this.$emit('add-new-homologation', res['new_homologation']);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo crear la homologación');
            });
    }

    postHarvestHomologation(data) {
        InsuranceServices.postHarvestHomologation(data)
            .then(res => {
                this.showSuccessLoadingDialog(res, 'Homologación creada con éxito');
                this.$emit('add-new-homologation', res['new_homologation']);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo crear la homologación');
            });
    }

    get validateEmail() {
        return [emailValidator, true];
    }

    patchHarvestHomologation(data) {
        let self = this;
        if (this.patchData) {
            let homologID = this.patchData['id'];
            InsuranceServices.patchHarvestHomologation(data, homologID)
                .then(response => {
                    self.$emit('patch-homologation', response['data']['updated_homologation']);
                    self.showSuccessLoadingDialog(response.data, 'Homologación modificada con éxito');
                })
                .catch(err => {
                    self.showCatchLoadingDialog(err, 'No se pudo modificar la homologación');
                });
        }
    }

    patchSowingHomologation(data) {
        let self = this;
        if (this.patchData) {
            let homologID = this.patchData['id'];
            InsuranceServices.patchSowingHomologation(data, homologID)
                .then(response => {
                    self.$emit('patch-homologation', response['data']['updated_homologation']);
                    self.showSuccessLoadingDialog(response.data, 'Homologación modificada con éxito');
                })
                .catch(err => {
                    self.showCatchLoadingDialog(err, 'No se pudo modificar la homologación');
                });
        }
    }

    postHomologation(data) {
        this.showLoadingDialog('Guardando Homologación...');
        if (this.isSowing) {
            this.postSowingHomologation(data);
        } else {
            this.postHarvestHomologation(data);
        }
    }

    patchHomologation(data) {
        this.showLoadingDialog('Modificando Homologación...');
        if (this.isSowing) {
            this.patchSowingHomologation(data);
        } else {
            this.patchHarvestHomologation(data);
        }
    }

    get getData() {
        let formData = {
            acknowledged: false,
            date:
                this.dateSelected.indexOf('T') > -1
                    ? this.dateSelected
                    : moment(this.dateSelected, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss'),
            harvest_type: Number(this.cropTypeSelected['id']),
            vehicle: this.vehicleID,
            user_email: this.emailValue,
            location: this.locationSelected,
            notes: this.noteDescription,
            work_width: Number(this.workWidthValue),
            current_vin: this.vinValue
        };
        if (!this.isSowing) {
            //add fields for harvest homologation
            this.$set(formData, 'flow_sensor_state', Number(this.flowStateSelected['id']));
            this.$set(formData, 'humidity_sensor_state', Number(this.humiditySelected['id']));
            this.$set(formData, 'monitor_type', this.monitorType);
        }
        if (this.isPatch) {
            let date_acknowledged = null;
            if (this.dateAcknowledge !== null) {
                date_acknowledged =
                    this.dateAcknowledge.indexOf('T') > -1
                        ? this.dateAcknowledge
                        : moment(this.dateAcknowledge, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss');
            }
            this.$set(formData, 'date_acknowledged', date_acknowledged);
            this.$set(
                formData,
                'acknowledged',
                this.patchData && this.patchData['acknowledged'] ? this.patchData['acknowledged'] : false
            );
        }
        return formData;
    }

    updateDateAcknowledge(value) {
        this.dateAcknowledge = value;
    }

    updateCropTypeSelected(value) {
        this.cropTypeSelected = value;
    }
    updateCropTypeRV(value) {
        this.cropTypeRV = value;
    }
    updateFlowStateSelected(value) {
        this.flowStateSelected = value;
    }
    updateFlowStateRV(value) {
        this.flowStateRV = value;
    }
    updateHumiditySelected(value) {
        this.humiditySelected = value;
    }
    updateHumidityRV(value) {
        this.humidityRV = value;
    }
    updateSelectedDate(value) {
        this.dateSelected = value;
    }
    updateMonitorType(value) {
        if (value == null) {
            value = '';
        }
        this.monitorType = value;
    }
    updateWorkWidthValue(value) {
        if (value === '') {
            value = null;
        }
        this.workWidthValue = value;
    }
    updateFlowSensorState(value) {
        if (value === '') {
            value = null;
        }
        this.flowSensorState = value;
    }
    updateVinValue(value) {
        if (value === '') {
            value = null;
        }
        this.vinValue = value;
    }
    updateIndependentSections(value) {
        if (value == null) {
            value = '';
        }
        this.independentSections = value;
    }
    updateEmail(value) {
        this.emailValue = value;
    }

    get formIsValid() {
        if (this.locationSelected == null) {
            this.errorMsg = 'Debe seleccionar una ubicación';
            return false;
        }
        if (this.dateSelected == null) {
            this.errorMsg = 'Debe asignar una fecha';
            return false;
        }

        if (this.vinValue == null) {
            this.errorMsg = 'Debe asignar un número de equipo';
            return false;
        }

        if (this.workWidthValue == null) {
            this.errorMsg = 'Falta ingresar el Ancho de trabajo';
            return false;
        }

        if (this.cropTypeSelected == null) {
            this.errorMsg = 'Debe seleccionar un tipo de cultivo';
            return false;
        }

        if (!this.isSowing) {
            if (this.flowStateSelected == null) {
                this.errorMsg = 'Falta seleccionar estado del sensor de flujo';
                return false;
            }
            if (this.humiditySelected == null) {
                this.errorMsg = 'Falta ingresar estado del sensor de humedad';
                return false;
            }
            if (this.monitorType === '') {
                this.errorMsg = 'Falta ingresar monitor';
                return false;
            }
        }

        if (emailValidator(this.emailValue) !== true) {
            this.errorMsg = 'E-mail inválido';
            return false;
        }

        this.errorMsg = '';
        return true;
    }

    @Emit()
    closeModal() {}

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.sensorStateOptions = this.$_getInsuranceProperties['sensor_states'];
            self.loadPatchData();
        });
    }

    get isPatch() {
        return this.patchData !== null ? true : false;
    }

    updateLocation(latLng) {
        this.locationSelected = latLng;
        this.location = latLng['lat'] + ' ; ' + latLng['lng'];
    }

    setCropType(patchData) {
        let indexCropType = matchedIndexIdInArray(this.cropTypes, patchData['harvest_type'].toString());
        if (indexCropType !== -1) {
            this.updateCropTypeSelected(this.cropTypes[indexCropType]);
        }
    }

    mapIsVisible() {
        /* This method is called when the Map has finished loading */
        if (this.isPatch) {
            this.setLocationOnMap(this.patchData);
        }
    }

    setLocationOnMap(patchData) {
        let self = this;
        this.$nextTick(() => {
            self.mapHomologation.placeMarkerOnMap(
                new google.maps.LatLng(patchData['location']['latitude'], patchData['location']['longitude'])
            );
        });
    }

    loadPatchData() {
        if (this.isPatch && this.patchData !== null) {
            this.modalTitle = 'Modificar Homologación de Siembra';
            this.updateSelectedDate(this.patchData['date']);
            this.noteDescription = this.patchData['notes'];
            this.updateWorkWidthValue(this.patchData['work_width']);
            this.updateVinValue(this.patchData['current_vin']);
            this.updateEmail(this.patchData['user_email']);
            this.setCropType(this.patchData);
            this.updateLocation({
                lat: this.patchData['location']['latitude'],
                lng: this.patchData['location']['longitude']
            });
            this.updateDateAcknowledge(this.patchData['date_acknowledged']);

            if (!this.isSowing) {
                this.assignHarvestFields(this.patchData);
            }
        } else {
            this.modalTitle = 'Agregar Nueva Homologación';
            this.updateDateAcknowledge(null);
        }
    }

    assignHarvestFields(patchData) {
        let indexFlowState = matchedIndexIdInArray(this.sensorStateOptions, patchData['flow_sensor_state'].toString());
        if (indexFlowState !== -1) {
            this.updateFlowStateSelected(this.sensorStateOptions[indexFlowState]);
        }
        let indexHumidityState = matchedIndexIdInArray(
            this.sensorStateOptions,
            patchData['humidity_sensor_state'].toString()
        );
        if (indexHumidityState !== -1) {
            this.updateHumiditySelected(this.sensorStateOptions[indexHumidityState]);
        }
        this.updateMonitorType(patchData['monitor_type']);
    }
}
